import { Link } from '@approvalmax/ui';
import { SimpleLayout, Text, useLayout } from '@approvalmax/ui/src/components';
import { Helmet } from 'react-helmet';

import { SlackConnectForm, SlackSuccess } from '../resources/components';
import { useSlackAuthConnectPage, useSlackAuthConnectPageData } from './resources/hooks';
import { messages } from './resources/messages';

const Page = () => {
    useLayout({ containerMinSize: 'xxsmall' });

    useSlackAuthConnectPage();

    const { isLoading, showSuccess, handleComplete, handleCancel, handleOpenSlack } = useSlackAuthConnectPageData();

    return (
        <SimpleLayout size={showSuccess ? 'xsmall' : 'small'}>
            <Helmet>
                <title>{messages.pageTitle}</title>
            </Helmet>

            <SimpleLayout.Content>
                {!showSuccess && (
                    <SlackConnectForm progress={isLoading} onSubmit={handleComplete} onCancel={handleCancel} />
                )}

                {showSuccess && (
                    <SlackSuccess
                        successText={messages.successMessage}
                        openSlackText={messages.openSlack}
                        onOpenSlack={handleOpenSlack}
                    />
                )}
            </SimpleLayout.Content>

            {!showSuccess && (
                <SimpleLayout.Footer>
                    <Text font='body' fontSize='medium' fontWeight='regular' textAlign='center'>
                        {messages.footerText({
                            terms: (chunks) => (
                                <Link href='https://www.approvalmax.com/terms' targetBlank>
                                    {chunks}
                                </Link>
                            ),
                        })}
                    </Text>
                </SimpleLayout.Footer>
            )}
        </SimpleLayout>
    );
};

Page.displayName = 'Page';

export default Page;
